export const features: {
  title: string;
  description: string;
  platforms: {
    title: string;
    icon: string;
    classname: string;
    fill: string;
  }[];
}[] = [
  {
    title: 'Liquidación de profesionales',
    description:
      'Permite ver prestaciones realizadas, los tipos de pago que pueden liquidarse y los totales de laboratorio.',
    platforms: [
      {
        title: 'Muy pronto en Mobile y Web',
        icon: 'rocket',
        classname: '!text-red-400 !bg-red-50',
        fill: '#ffff',
      },
      {
        title: 'Escritorio',
        icon: 'desktop',
        classname: '!text-green-600 !bg-green-50',
        fill: '#ffff',
      },
    ],
  },
  {
    title: 'Liquidación de obras sociales / Seguros médicos',
    description:
      'Cuenta con la posibilidad de ejecutar liquidaciones para pagos a seguro seguro médicos, según prestaciones realizadas y listado de profesionales.',
    platforms: [
      {
        title: 'Mobile',
        icon: 'mobile',
        classname: '!text-amber-600 !bg-amber-50',
        fill: '#ffff',
      },
      {
        title: 'Web',
        icon: 'world',
        classname: '!text-violet-600 !bg-violet-50',
        fill: '#ffff',
      },
      {
        title: 'Escritorio',
        icon: 'desktop',
        classname: '!text-green-600 !bg-green-50',
        fill: '#ffff',
      },
    ],
  },
  {
    title: 'Liquidación de auditor',
    description:
      'Ofrece opciones de filtrado por obras sociales, grupos, profesionales y periodos.',
    platforms: [
      {
        title: 'Mobile',
        icon: 'mobile',
        classname: '!text-amber-600 !bg-amber-50',
        fill: '#ffff',
      },
      {
        title: 'Web',
        icon: 'world',
        classname: '!text-violet-600 !bg-violet-50',
        fill: '#ffff',
      },
      {
        title: 'Escritorio',
        icon: 'desktop',
        classname: '!text-green-600 !bg-green-50',
        fill: '#ffff',
      },
    ],
  },
];
